import React from 'react';
import { Button } from 'reactstrap';

import { EthernalSVG } from './utils/EternalIcon';

export const EternalBtn = ({ children, action }) => {
  return (
    <Button className='custom-btn btn-pill btn-air-primary f-w-500 f-16' color='primary' onClick={() => action()}>
      <EthernalSVG />
      {children}
    </Button>
  );
};
